var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._g(_vm._b({attrs:{"items":_vm.duree,"item-value":"id","data-testid":_vm.dataTestid},on:{"input":_vm.changed},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}},'v-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }